import {ToastContainer} from 'react-toastify';
import AppRoutes from './AppRoutes';
import {useTheme} from './hooks/useTheme';

function App() {
    const {theme} = useTheme();

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={4000}
                theme={theme}
            />
            <AppRoutes />
        </>
    );
}

export default App;
